module.exports = __webpack_public_path__ + "static/media/webstudio.79cddb02.svg";